/**
 * Enum con todas las claves de configuración del sistema
 * Úsalo en place de strings para type-safety y autocomplete
 */
export enum ConfigurationKey {
  // ===== Facturación Electrónica =====
  HabilitarFactura = "HabilitarFactura",
  HabilitarAutofactura = "HabilitarAutofactura",
  HabilitarNotaCredito = "HabilitarNotaCredito",

  // ===== OperationalMode =====
  OperationalMode = "OperationalMode",
}
